import {
  Field, Form, ErrorMessage, defineRule, configure,
} from 'vee-validate';
import {
  required, email, min, max,
} from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';
import en from '@vee-validate/i18n/dist/locale/en.json';
import tr from '@vee-validate/i18n/dist/locale/tr.json';

export default {
  install: (app) => {
    app.component('VeeForm', Form);
    app.component('VeeField', Field);
    app.component('VeeErrorMessage', ErrorMessage);

    defineRule('required', required);
    defineRule('email', email);
    defineRule('min', min);
    defineRule('max', max);

    configure({
      validateOnInput: true,
      validateOnChange: true,
      validateOnBlur: true,
      validateOnModelUpdate: true,
      generateMessage: localize({
        en,
        tr,
      }),
    });
  },
};
